import * as React from 'react'
import useStyles from './mapComponentRoot.css'

const MapComponentRoot: React.FC = ({ children }) => {
    const classes = useStyles()
    return <div className={classes.root}>{children}</div>
}

export default MapComponentRoot
